export const MAX_FILE_SIZE_BYTES = 500000;

export const ASPECT_RATIO_4to3 = 1 + (1 / 3);

export const ASPECT_RATIO_3to2 = 1 + (1 / 2);

export const PRESET_WEB_SIZES = Object.freeze([{
    width: 2100,
    height: 1400,
    ratio: 1 + (1 / 2)
}, {
    width: 1920,
    height: 1440,
    ratio: 1 + (1 / 3)
}, {
    width: 1800,
    height: 1200,
    ratio: 1 + (1 / 2)
}]);

export const ALLOWED_WATERMARK_FILE_TYPES = Object.freeze([
    'image/png',
]);

export const ALLOWED_PROFILE_LOGO_FILE_TYPES = Object.freeze([
    'image/png',
    'image/jpeg',
]);

export const DEFAULT_WEB_SIZE = Object.freeze({
    width: 2100,
    height: 1400,
    ratio: 1 + (1 / 2)
});